import Text from '../../components/Text';
import MyInvestmentsFunctional from './index.function';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../../components/ViewReverse';
import { CardView } from '../Overview/components';
import LoaderModal from '../../components/LoaderModal';
import { formatNumbers } from '../../utils/utils';

const MyInvestments = () => {
  const {
    getContentKey,
    TextWeight,
    investment_loading,
    direction,
    navigate,
    investment_details,
    isArabic
  } = MyInvestmentsFunctional();

  return (
    <div>

      <Text
        text={getContentKey('my_investments_heading')}
        size={fontSizes.h24}
        weight={TextWeight.bold}
        color='text-black'
      />
      <div
        dir={direction}
        className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 justify-between"}>
        <CardView title={getContentKey('total_no_of_units')} amount={investment_details?.totalHoldingUnits ?? 0} />
        <CardView title={getContentKey('total_current_nav')} amount={investment_details?.totalCurrentMarketValue ?? 0} />
        <CardView title={getContentKey('total_cost')} amount={investment_details?.totalCostUnits ?? 0} />
      </div>

      {
        investment_details?.funds?.length > 0 ?
          <div dir={direction} className='gap-4 grid grid-cols-1 md:grid-cols-2 mt-6'>
            {
              investment_details?.funds?.map((item, index) => {
                return (
                  <div onClick={() => navigate('/investments/manage-investments/my-investments-detail', { state: { data: item } })} className='flex-1 border-grey border rounded-xl p-4 cursor-pointer' >
                    <Text weight={TextWeight.semiBold}
                      size={fontSizes.h16}
                      text={isArabic ? item?.fundName_AR : item?.fundName_EN} />

                    <ViewReverse className={'mt-2'} >
                      <div className='flex-1' >
                        <Text size={fontSizes.h14} weight={TextWeight.medium} text={formatNumbers(item?.holdingUnits, 4)} className={'text-primary'} />
                        <Text className={'text-silver'} text={getContentKey("number_of_units_owned")} />
                      </div>
                      <div className='flex-1' >
                        <Text size={fontSizes.h14} weight={TextWeight.medium} text={formatNumbers(item?.costOfUnitsOwned)} className={'text-primary'} />
                        <Text className={'text-silver'} text={getContentKey("cost_of_units_owned")} />
                      </div>
                    </ViewReverse>

                    <ViewReverse className={'mt-2'} >
                      <div className='flex-1' >
                        <Text size={fontSizes.h14} weight={TextWeight.medium} text={item?.nav} className={'text-primary'} />
                        <Text className={'text-silver'} text={getContentKey("nav")} />
                      </div>
                      <div className='flex-1' >
                        <Text size={fontSizes.h14} weight={TextWeight.medium} text={item?.currentNav} className={'text-primary'} dir={"ltr"} />
                        <Text className={'text-silver'} text={getContentKey("current_nav")} />
                      </div>
                    </ViewReverse>
                  </div>

                )
              })
            }
          </div>
          :
          <Text
            text={getContentKey('no_investments_found')}
            size={fontSizes.h16}
            isCenter
            className={'mt-10 text-center'}
          />
      }

      {/* {investment_details?.funds?.length > 0 ? (
        investment_details?.funds?.map((item, index) => (
          <div className='border border-grey rounded-xl mt-4 pt-4 px-5 pb-4 shadow-light' key={index}>
            <ViewReverse className='items-center justify-between'>
              <Text text={isArabic ? item?.fundName_AR : item?.fundName_EN} size={fontSizes.h16} weight={TextWeight.semiBold} isTruncate={false} color='text-black' />

              <Button
                text={getContentKey('view_reports')}
                bgColor='bg-primary'
                className=' w-36 px-0 text-center capitalize'
                onClick={() => {
                  navigate('/investments/my-fund-reports');
                }}
              />
            </ViewReverse>

        

            <div dir={direction} className='grid grid-cols-1 lg:grid-cols-2 mt-4 gap-5'>
              <div>
                {item?.details?.map((detail, index) => (
                <HoldingView item={item} getContent={getContentKey} key={index} /> 
                ))}
              </div>
              <Chart chartData={item?.chartData} />
            </div>
          </div>
        ))
      ) : (
        <Text text={getContentKey('my_investment_funds')} size={fontSizes.h16} weight={TextWeight.semiBold} className='mt-6' />
      )} */}
      <LoaderModal open={investment_loading} />
    </div>
  );
};

export default MyInvestments;
